import React, { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form'
import PropTypes from 'prop-types'
import { get } from 'lodash'

import Typography from 'components/atoms/Typography'
import CustomButton from 'components/atoms/CustomButton'

import './FilterModal.scss'

function FilterModal({ field, text, onSubmit, items, selectAllText, oneOption }) {
  const [active, setActive] = useState(false)
  const [values, setValues] = useState(getSelectedValues(items, field))

  const handleClose = () => setActive(false)
  const handleShow = () => setActive(true)

  const handleChange = (value, target) => {
    if (target?.checked) {
      addValue(value)
    } else {
      removeValue(value)
    }
  }
  const handleSubmit = () => {
    if (onSubmit) onSubmit(values)
    handleClose()
  }

  function addValue(value) {
    setValues((values) => {
      const currentValues = oneOption ? [] : values
      const newValues = field ? { value, field } : value
      return [...currentValues, newValues]
    })
  }

  function getSelectedValues(items, field) {
    return items?.map((subitem) => subitem.selected && { ...subitem, field }).filter((item) => item)
  }

  function removeValue(value) {
    setValues((values) => {
      if (field)
        return values?.map((currentVal) => {
          if (currentVal.value === value && currentVal?.field === field) {
            return currentVal
          }
          return { ...currentVal, selected: true }
        })
      return values?.filter((currentVal) => !(currentVal === value))
    })
  }

  function handleSelectAll({ target: { checked } }) {
    if (checked) {
      if (oneOption) {
        setValues([{ field, value: undefined }])
      } else {
        items.forEach(({ value }) => {
          if (!values.find((currentValue) => currentValue.value === value)) {
            addValue(value)
          }
        })
      }
    }
  }

  useEffect(() => {
    setValues(getSelectedValues(items, field))
  }, [items])

  // block scroll
  useEffect(() => {
    const body = document.querySelector('body')
    if (active === false) {
      body.style.overflowY = 'auto'
    } else {
      body.scrollTo(0, 0)
      body.style.overflowY = 'hidden'
    }
  }, [active])

  return (
    <>
      <button className="FilterModalButton" onClick={handleShow}>
        <span>{text}</span>
      </button>

      <section className={`filter-modal ${active ? 'active' : ''}`}>
        <div className="overlay overlay-light" />
        <nav className={`filter-modal-menu ${active ? 'active' : ''}`}>
          <section className="filter-modal-menu-header">
            <Typography variant="h6" color="primary" cssClass="filter-modal-title">
              Filtrar por {text.toLowerCase()}
            </Typography>

            <button onClick={handleClose}>
              <i className="icone-close-book" />
            </button>
          </section>

          {Array.isArray(items) &&
            items
              .filter((i) => Array.isArray(i.items))
              .map((item) => (
                <details className="filter-modal-menu-drop" key={get(item, 'name')}>
                  <summary>{get(item, 'name')}</summary>
                  <nav>
                    <ul>
                      {Array.isArray(item.items) &&
                        item.items.map((item) => (
                          <li key={get(item, 'name')}>
                            <Form.Group controlId="filters">
                              <Form.Check
                                defaultChecked={subitem.selected}
                                onChange={({ target }) => handleChange(subitem.value, target)}
                                label={get(item, 'name')}
                                type="checkbox"
                              />
                            </Form.Group>
                          </li>
                        ))}
                    </ul>
                  </nav>
                </details>
              ))}

          <nav className="filter-modal-menu-drop">
            <ul>
              {selectAllText && (
                <li>
                  <Form.Group controlId={'filters-all'} className="filter-modal-menu-link">
                    <Form.Check
                      id={selectAllText}
                      label={selectAllText}
                      type="checkbox"
                      checked={
                        values?.length === 0 ||
                        values.length === items.length ||
                        (values?.length > 0 && values[0].value === undefined)
                      }
                      onChange={handleSelectAll}
                    />
                  </Form.Group>
                </li>
              )}

              {Array.isArray(items) &&
                items.map((item, index) => {
                  return (
                    <li key={get(item, 'name')}>
                      <Form.Group controlId={'filters' + index} className="filter-modal-menu-link">
                        <Form.Check
                          checked={!!values.find(({ value }) => value === item.value)}
                          id={get(item, 'name')}
                          label={get(item, 'name')}
                          onChange={({ target }) => handleChange(item.value, target)}
                          type="checkbox"
                        />
                      </Form.Group>
                    </li>
                  )
                })}
            </ul>
          </nav>

          <section className="filter-modal-menu-footer">
            <div className="filter-modal-menu-footer-buttons">
              <CustomButton color={`outline-primary`} text="Fechar" onClick={handleClose} noIcon className="mr-2" />
              <CustomButton color={`primary`} text="Filtrar" onClick={handleSubmit} noIcon />
            </div>
          </section>
        </nav>
      </section>
    </>
  )
}

FilterModal.propTypes = {
  field: PropTypes.string,
  text: PropTypes.string,
  onSubmit: PropTypes.func,
  items: PropTypes.array,
  selectAllText: PropTypes.string,
  oneOption: PropTypes.bool,
}

export default FilterModal
